<template>
    <div class="grant-agreement" v-if="MonitoringForm.initialized">
        <div class="grant-agreement-box row" v-if="!showContractDetails">
            <div class="col-6">
                <h3>{{ $t('monitoring.title__grant_agreement') }} - {{ MonitoringForm.reference }}</h3>

                <p v-if="loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN"><b>{{ $t('monitoring.field_title__number_of_project') }}</b>: <input type="text" v-model="MonitoringForm.model.project_number" /></p>
                <p v-else><b>{{ $t('monitoring.field_title__number_of_project') }}</b>: {{ MonitoringForm.model.project_number }}</p>
                <p><b>{{ $t('monitoring.field_title__name_of_organisation') }}</b>: {{ MonitoringForm.organisation }}</p>
                <p v-if="loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN"><b>{{ $t('monitoring.field_title__bank_account') }}</b>: <input type="text" v-model="MonitoringForm.model.bank_account" /></p>
                <p v-else><b>{{ $t('monitoring.field_title__bank_account') }}</b>: {{ MonitoringForm.model.bank_account }}</p>
            </div>
            <div class="col-6">
                <base-button
                    type="primary"
                    class="pull-right"
                    @click.native="showContractDetails = true"
                    >
                    {{ $t('monitoring.button__view_contract_details') }}
                </base-button>
            </div>
        </div>
        <div v-else>
            <div class="grant-agreement-box row">
                <div class="col-6">
                    <h3 class="mt-2 mb-0">{{ $t('monitoring.title__grant_agreement') }} - {{ MonitoringForm.reference }}</h3>
                </div>
                <div class="col-6">
                    <base-button
                        type="primary"
                        class="pull-right"
                        @click="viewOriginalProposal"
                        >
                        {{ $t('monitoring.button__view_original_proposal') }}
                    </base-button>
                </div>
            </div>
            <card class="mt-5">
                <div class="row">
                    <div class="col-lg-4">
                        <!-- Title of the project -->
                        <div class="form-group">
                            <h4 class="card-title">{{$t("small_technical_grants_assessments.general_info__project_title_card_title")}}</h4>
                            <textarea
                                class="form-control"
                                name="grant_agreement.title"
                                v-model="MonitoringForm.title"
                                v-validate="'required'"
                                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                :placeholder="$t('small_technical_grants_assessments.general_info__project_title_placeholder')"
                                >
                            </textarea>
                        </div>

                         <!-- 2. Name of the lead applicant -->
                        <div class="form-group">
                            <h4 class="card-title">{{$t("small_technical_grants_assessments.general_info__lead_applicant_name_card_title")}}</h4>
                            <textarea
                                class="form-control"
                                name="grant_agreement.lead_applicant_name"
                                v-model="MonitoringForm.model.grant_agreement.lead_applicant_name"
                                v-validate="'required'"
                                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                :error="getError('grant_agreement.lead_applicant_name')"
                                :data-vv-as="$t('small_technical_grants_assessments.general_info__lead_applicant_name_card_title')"
                                :label="$t('small_technical_grants_assessments.general_info__lead_applicant_name_card_title')"
                                :placeholder="$t('small_technical_grants_assessments.general_info__lead_applicant_name_placeholder')"
                                >
                            </textarea>
                        </div>

                        <!-- 3. Type of organisation of the lead applicant -->
                        <h4 class="card-title">{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_card_title")}}</h4>
                        <div class="form-group">
                            <h6>{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_instructions")}}</h6>
                            <div class="mt-4"></div>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.organisation_type_government"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_1")}}
                            </base-checkbox>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.organisation_type_protected"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_2")}}
                            </base-checkbox>
                            <!-- new -->
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.organisation_transboundary_conservation_areas"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_3")}}
                            </base-checkbox>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.co_applicant_involved_protected_conserved"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_4")}}
                            </base-checkbox>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.organisation_network_protected_areas"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_5")}}
                            </base-checkbox>
                            <!-- new -->
                        </div>

                        <!-- 4. Name of the co-applicant (if any)  -->
                        <div class="form-group">
                            <h4 class="card-title">{{$t("small_technical_grants_assessments.general_info__co_applicant_name_card_title")}}</h4>
                            <textarea
                                class="form-control"
                                name="grant_agreement.name_of_co_applicants"
                                v-model="MonitoringForm.model.grant_agreement.name_of_co_applicants"
                                v-validate="'required'"
                                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                :error="getError('grant_agreement.name_of_co_applicants')"
                                :data-vv-as="$t('small_technical_grants_assessments.general_info__co_applicant_name_card_title')"
                                :label="$t('small_technical_grants_assessments.general_info__co_applicant_name_card_title')"
                                :placeholder="$t('small_technical_grants_assessments.general_info__co_applicant_name_placeholder')"
                                >
                            </textarea>
                        </div>

                        <!-- 5. Type of organisation of the co-applicant  -->
                        <h4 class="card-title">{{$t("small_technical_grants_assessments.general_info__co_applicant_organisation_card_title")}}</h4>
                        <div class="form-group">
                            <h6>{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_instructions")}}</h6>
                            <div class="mt-4"></div>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.co_applicant_organisation_type_government"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_1")}}
                            </base-checkbox>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.co_applicant_organisation_type_protected"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_2")}}
                            </base-checkbox>
                            <!-- new -->
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.co_applicant_transboundary_conservation_areas"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_3")}}
                            </base-checkbox>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.organisation_involved_protected_conserved"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_4")}}
                            </base-checkbox>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.co_applicant_network_protected_areas"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_5")}}
                            </base-checkbox>
                            <!-- new -->
                        </div>

                        <!-- Region -->
                        <div class="form-group">
                            <h4 class="card-title">{{$t("small_technical_grants_assessments.general_info__region_card_title")}}</h4>
                            <!-- <label for="regionSelect">{{ $t('medium_grant.technical__1_region') }}</label> -->
                            <select
                                class="form-control"
                                @change="setRegion($event)"
                                v-model="MonitoringForm.model.region_id"
                                name="grant_agreement.region"
                                id="regionSelect"
                                v-validate="'required'"
                                :data-vv-as="$t('small_technical_grants_assessments.general_info__region_card_title')"
                                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                >
                                <option value="" selected="selected">{{ $t('medium_grant.general__please_select') }}</option>
                                <option :value="region.regionId" :selected="MonitoringForm.regionId === region.regionId" v-for="region in regions" :key="region.regionId">{{region.code}} - {{region.name}}</option>
                            </select>
                        </div>

                        <!-- ACP Country(ies) -->
                        <div class="form-group">
                            <h4 class="card-title">{{$t("small_technical_grants_assessments.general_info__acp_country_card_title")}}</h4>
                            <multiselect
                                name="grant_agreement.acp_country"
                                v-model="MonitoringForm.model.grant_agreement.acp_country"
                                selectLabel=""
                                selectedLabel=""
                                deselectLabel="Clear"
                                v-validate="'required'"
                                label="name"
                                track-by="countryId"
                                :data-vv-as="$t('small_technical_grants_assessments.technical__1_acp_country')"
                                :tag-placeholder="$t('small_technical_grants_assessments.general__please_select')"
                                :placeholder="$t('small_technical_grants_assessments.general__please_select')"
                                :options="countriesByRegion"
                                :multiple="true"
                                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                >
                            </multiselect>
                        </div>

                        <!-- 8. Priority Area targeted  -->
                        <h4 class="card-title">{{$t("small_technical_grants_assessments.general_info__priority_area_targeted_card_title")}}</h4>
                        <h6>{{$t("small_technical_grants_assessments.general_info__priority_area_targeted_instructions")}}</h6>
                        <div class="form-group">
                            <h6>{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_instructions")}}</h6>
                            <div class="mt-4"></div>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.priority_area_targeted_marine_protected"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_1")}}
                            </base-checkbox>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.priority_area_targeted_marine_managed"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_2")}}
                            </base-checkbox>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.priority_area_targeted_terrestrial_protected"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_3")}}
                            </base-checkbox>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.priority_area_targeted_community_conserved"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_4")}}
                            </base-checkbox>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.priority_area_targeted_privately_protected    "
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_5")}}
                            </base-checkbox>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.priority_area_targeted_conservancy"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_1")}}
                            </base-checkbox>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.priority_area_targeted_key_landscape"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_2")}}
                            </base-checkbox>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.priority_area_targeted_k_b_as"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_3")}}
                            </base-checkbox>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.priority_area_targeted_transboundary"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_4")}}
                            </base-checkbox>
                            <base-checkbox
                                name="checkbox"
                                v-model="MonitoringForm.model.grant_agreement.priority_area_targeted_protected_areas"
                            >{{$t("small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_5")}}
                            </base-checkbox>
                        </div>

                        <!-- Priority Landscape Conservation targeted
                        <div class="form-group">
                            <h4 class="card-title">{{ $t('medium_grant.technical__1_priority_landscape') }}</h4>
                            <textarea
                                class="form-control"
                                name="grant_agreement.priority_landscape"
                                v-model="MonitoringForm.model.grant_agreement.priority_landscape"
                                v-validate="'required'"
                                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                :error="getError('grant_agreement.priority_landscape')"
                                :data-vv-as="$t('medium_grant.technical__1_priority_landscape')"
                                :label="$t('medium_grant.technical__1_priority_landscape')"
                                :placeholder="$t('medium_grant.technical__1_priority_landscape')"
                                >
                            </textarea>
                        </div> -->

                        <!-- PA(s) targeted -->
                        <div class="form-group">
                            <h4 class="card-title">{{$t("small_technical_grants_assessments.general_info__pa_registration_number_card_title")}} </h4>
                            <textarea
                                class="form-control"
                                name="grant_agreement.pa_registration_number"
                                v-model="MonitoringForm.model.grant_agreement.pa_registration_number"
                                v-validate="'required'"
                                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                :error="getError('grant_agreement.pa_registration_number')"
                                :data-vv-as="$t('small_technical_grants_assessments.general_info__pa_registration_number_card_title')"
                                :label="$t('small_technical_grants_assessments.general_info__pa_registration_number_card_title')"
                                :placeholder="$t('small_technical_grants_assessments.general_info__pa_registration_number_placeholder')"
                                >
                            </textarea>
                        </div>

                        <!-- 10. PA(s) supervisory authority -->
                        <div class="form-group">
                            <h4 class="card-title">{{$t("small_technical_grants_assessments.general_info__pa_supervisory_authority_card_title")}}</h4>
                            <textarea
                                class="form-control"
                                name="grant_agreement.pa_supervisory_authority"
                                v-model="MonitoringForm.model.grant_agreement.pa_supervisory_authority"
                                v-validate="'required'"
                                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                :error="getError('grant_agreement.pa_supervisory_authority')"
                                :data-vv-as="$t('small_technical_grants_assessments.general_info__pa_supervisory_authority_card_title')"
                                :label="$t('small_technical_grants_assessments.general_info__pa_supervisory_authority_card_title')"
                                :placeholder="$t('small_technical_grants_assessments.general_info__pa_supervisory_authority_placeholder')"
                                >
                            </textarea>
                        </div>

                        <!-- Reporting interval -->
                        <!-- <h4 class="card-title">{{ $t('monitoring.field_title_reporting_interval') }}</h4>
                        <div class="form-group">
                            <radio name="model.frequency"
                                class="form-check-inline"
                                value="3"
                                v-model="MonitoringForm.model.frequency"
                                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                >
                                <label>3 Months</label>
                            </radio>
                            <radio name="model.frequency"
                                class="form-check-inline"
                                value="6"
                                v-model="MonitoringForm.model.frequency"
                                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                >
                                <label>6 Months</label>
                            </radio>
                        </div> -->

                        <!-- Reporting interval -->
                        <h4 class="card-title">{{ $t('small_technical_grants_assessments.field_title_reporting_interval') }}</h4>
                        <div class="form-group">
                            <!-- <radio
                                name="model.reporting_interval"
                                class="form-check-inline"
                                value="1"
                                v-model="MonitoringForm.model.frequency"
                                >
                                <label>Monthly</label>
                            </radio> -->
                            <radio name="model.reporting_interval"
                                class="form-check-inline"
                                value="2"
                                v-model="MonitoringForm.model.frequency"
                                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                >
                                <label>2 Months</label>
                            </radio>
                            <radio name="model.reporting_interval"
                                class="form-check-inline"
                                value="5"
                                v-model="MonitoringForm.model.frequency"
                                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                >
                                <label>5 Months</label>
                            </radio>
                        </div>

                        <!-- Duration -->
                        <div class="form-group">
                            <h4 class="card-title">{{$t("small_technical_grants_assessments.general_info__duration_card_title")}}</h4>
                            <textarea
                                class="form-control"
                                name="grant_agreement.duration"
                                v-model="MonitoringForm.model.grant_agreement.duration"
                                v-validate="'required'"
                                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                :error="getError('grant_agreement.duration')"
                                :data-vv-as="$t('small_technical_grants_assessments.general_info__duration_card_title')"
                                :label="$t('small_technical_grants_assessments.general_info__duration_card_title')"
                                :placeholder="$t('small_technical_grants_assessments.technical__1_duration')"
                                >
                            </textarea>
                        </div>

                        <!-- Start & End date -->
                        <div class="row">
                            <!-- Starting date -->
                            <div class="col-lg-6">
                                <h4 class="card-title">{{ $t('small_technical_grants_assessments.technical__1_startdate') }}</h4>
                                <base-input
                                    name="grant_agreement.start_date"
                                    v-model="MonitoringForm.model.grant_agreement.start_date"
                                    :error="getError('grant_agreement.start_date')"
                                    v-validate="'required'"
                                    :data-vv-as=" $t('small_technical_grants_assessments.technical__1_startdate')"
                                    :placeholder="$t('small_technical_grants_assessments.technical__1_startdate')"
                                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                    >
                                    <el-date-picker
                                        type="date"
                                        v-model="startDate"
                                        :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                        :placeholder="$t('small_technical_grants_assessments.technical__1_startdate')"
                                        >
                                    </el-date-picker>
                                </base-input>
                            </div>

                            <!-- Ending date -->
                            <div class="col-lg-6">
                                <h4 class="card-title">{{ $t('small_technical_grants_assessments.technical__1_enddate') }}</h4>
                                <base-input
                                    name="grant_agreement.end_date"
                                    v-model="MonitoringForm.model.grant_agreement.end_date"
                                    :placeholder="$t('small_technical_grants_assessments.technical__1_enddate')"
                                    :error="getError('grant_agreement.end_date')"
                                    v-validate="'required'"
                                    :data-vv-as="$t('small_technical_grants_assessments.technical__1_enddate')"
                                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                    >
                                    <el-date-picker
                                        type="date"
                                        v-model="endDate"
                                        :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                        :placeholder="$t('small_technical_grants_assessments.technical__1_enddate')"
                                        >
                                    </el-date-picker>
                                </base-input>
                            </div>
                        </div>

                        <!-- extended End date - by alan-->
                        <div class="row" v-show="showDates">
                            <!-- end date 1-->
                            <div class="col-lg-6">
                                <h4 class="card-subtitle-new">a.{{ $t('monitoring.label_amended_date1') }}</h4>
                                <base-input
                                    name="grant_agreement.amendment_end_date_first"
                                    v-model="MonitoringForm.model.grant_agreement.amendment_end_date_first"
                                    :placeholder="$t('monitoring.label_amended_date1')"
                                    :error="getError('grant_agreement.amendment_end_date_first')"
                                    v-validate="'required'"
                                    :data-vv-as="$t('monitoring.label_amended_date1')"
                                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN || MonitoringForm.model.grant_agreement.end_date === null"
                                    >
                                    <el-date-picker
                                        type="date"
                                        v-model="amendEndDate1"
                                        :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN || MonitoringForm.model.grant_agreement.end_date === null"
                                        :placeholder="$t('monitoring.label_amended_date1')"
                                        >
                                    </el-date-picker>
                                </base-input>
                            </div>

                            <!-- end date 2 -->
                            <div class="col-lg-6">
                                <h4 class="card-subtitle-new">b.{{ $t('monitoring.label_amended_date2') }}</h4>
                                <base-input
                                    name="grant_agreement.amendment_end_date_second"
                                    v-model="MonitoringForm.model.grant_agreement.amendment_end_date_second"
                                    :placeholder="$t('monitoring.label_amended_date2')"
                                    :error="getError('grant_agreement.amendment_end_date_second')"
                                    v-validate="'required'"
                                    :data-vv-as="$t('monitoring.label_amended_date2')"
                                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN || MonitoringForm.model.grant_agreement.amendment_end_date_first === null"
                                    >
                                    <el-date-picker
                                        type="date"
                                        v-if="showAmendDate2"
                                        v-model="amendEndDate2"
                                        :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN || MonitoringForm.model.grant_agreement.amendment_end_date_first === null"
                                        :placeholder="$t('monitoring.label_amended_date2')"
                                        >
                                    </el-date-picker>
                                </base-input>
                            </div>
                        </div>

                        <!-- Total budget -->
                        <div class="form-group">
                            <h4 class="card-title">{{$t("small_technical_grants_assessments.general_info__total_annual_budget_card_title")}}</h4>
                            <textarea
                                class="form-control"
                                name="grant_agreement.total_pa_anual_budget"
                                v-model="MonitoringForm.model.grant_agreement.total_pa_anual_budget"
                                v-validate="'required'"
                                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                :error="getError('grant_agreement.total_pa_anual_budget')"
                                :data-vv-as="$t('small_technical_grants_assessments.general_info__total_annual_budget_card_title')"
                                :label="$t('small_technical_grants_assessments.general_info__total_annual_budget_card_title')"
                                :placeholder="$t('small_technical_grants_assessments.general_info__total_annual_budget_placeholder')"
                                >
                            </textarea>
                        </div>

                        <!-- Total funding requested -->
                        <div class="form-group">
                            <h4 class="card-title">{{$t("small_technical_grants_assessments.general_info__total_funding_requested_card_title")}}</h4>
                            <textarea
                                class="form-control"
                                name="grant_agreement.total_funding_requested"
                                v-model="MonitoringForm.model.grant_agreement.total_funding_requested"
                                v-validate="'required'"
                                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                :error="getError('grant_agreement.total_funding_requested')"
                                :data-vv-as="$t('small_technical_grants_assessments.general_info__total_funding_requested_card_title')"
                                :label="$t('small_technical_grants_assessments.general_info__total_funding_requested_card_title')"
                                :placeholder="$t('small_technical_grants_assessments.general_info__total_funding_budget_placeholder')"
                                >
                            </textarea>
                        </div>

                        <!-- Total Co-funding -->
                        <!-- <div class="form-group">
                            <h4 class="card-title">{{ $t('medium_grant.technical__1_total_cofunding') }}</h4>
                            <textarea
                                class="form-control"
                                name="grant_agreement.total_co_funding"
                                v-model="MonitoringForm.model.grant_agreement.total_funding_requested"
                                v-validate="'required'"
                                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                :error="getError('grant_agreement.total_co_funding')"
                                :data-vv-as="$t('medium_grant.technical__1_total_cofunding')"
                                :label="$t('medium_grant.technical__1_total_cofunding')"
                                :placeholder="$t('medium_grant.technical__1_total_cofunding')"
                                >
                            </textarea>
                        </div> -->

                <!-- 14. Type of assessment you want to undertake and tick the relevant box(es) below   -->
                <h4 class="card-title">{{$t("small_technical_grants_assessments.type_of__assessment_to_undertake_card_title")}}</h4>
                <base-checkbox
                    name="checkbox"
                    v-model="MonitoringForm.model.grant_agreement.type_of_assessment_i_m_e_t"
                >
                    {{$t("small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_1")}}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="MonitoringForm.model.grant_agreement.type_of_assessment_m_e_t_t"
                >
                    {{$t("small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_2")}}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="MonitoringForm.model.grant_agreement.type_of_assessment_r_a_p_p_a_m"
                >
                    {{$t("small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_3")}}
                </base-checkbox>

                <base-checkbox
                    name="checkbox"
                    v-model="MonitoringForm.model.grant_agreement.type_of_assessment_i_u_c_n"
                >
                    {{$t("small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_4")}}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="MonitoringForm.model.grant_agreement.type_of_assessment_e_o_h"
                >
                    {{$t("small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_5")}}
                </base-checkbox>

                <base-checkbox
                    name="checkbox"
                    v-model="MonitoringForm.model.grant_agreement.type_of_assessment_s_a_p_a"
                >
                    {{$t("small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_7")}}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="MonitoringForm.model.grant_agreement.type_of_assessment_s_a_g_e"
                >
                    {{$t("small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_8")}}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="MonitoringForm.model.grant_agreement.type_of_assessment_g_a_p_a"
                >
                    {{$t("small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_9")}}
                </base-checkbox>

                <base-checkbox
                    name="checkbox"
                    v-model="MonitoringForm.model.grant_agreement.equivalent_assessment"
                >
                    {{$t("small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_6")}}
                </base-checkbox>
                <label
                    style="font-size: 10px; margin-left: 25px; font-weight: 600"
                >
                    {{$t("small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_instructions")}}
                </label>

                <div v-if="MonitoringForm.model.grant_agreement.equivalent_assessment">
                    <input
                        class="form-control"
                        type="text"
                        name="grant_agreement.custom_equivalent_assessment"
                        v-model="MonitoringForm.model.grant_agreement.custom_equivalent_assessment"
                        :error="getError('grant_agreement.custom_equivalent_assessment')"
                        v-validate="'required'"
                        :placeholder="$t('small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_placeholder')"
                    />
                </div>

                </div>
                <MonitoringGrantAgreementsQuestions
                    v-bind:loggedUser="loggedUser"
                    v-bind:UserRoles="UserRoles"
                    v-bind:MonitoringForm="MonitoringForm"
                />
                </div>
            </card>
            <div class="row mb-5">
                <div class="col-12">
                    <div class="grant-agreement-box row mt-5">
                        <div class="col-12">
                            <div class="form-group file-group">
                                <span class="file-caption">{{ $t('monitoring.box_title__signed_contract') }}</span>
                                <upload-file
                                    v-if="MonitoringForm.initialized"
                                    v-model="MonitoringForm.files.grant_agreement.signed_contract"
                                    class="upload-file"
                                    section="grant_agreement.signed_contract"
                                    select-text="Admin Upload Contract"
                                    :file-data="MonitoringForm.files.grant_agreement.signed_contract"
                                    :is-editable="loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN"
                                    :model-name="'Monitoring'"
                                    :size-limit="MonitoringForm.fileSizeLimit"
                                >
                                </upload-file>
                            </div>
                        </div>
                    </div>

                    <div class="ammendment-box mt-3 row" v-for="(amend, index) in MonitoringForm.model.grant_agreement.contract_amends" :key="'contract_' + index">
                        <div class="col-12">
                            <div class="form-group file-group">
                                <span class="file-caption">{{ $t('monitoring.box_title__amend_request', [index + 1]) }}</span>
                                <upload-file
                                    v-if="MonitoringForm.initialized"
                                    v-model="MonitoringForm.files.grant_agreement['amend_' + index + '_signed_contract']"
                                    class="upload-file"
                                    :select-text="$t('monitoring.button_title_upload_ammended_contract')"
                                    :section="'grant_agreement.amend_' + index + '_signed_contract'"
                                    :file-data="MonitoringForm.files.grant_agreement['amend_' + index + '_signed_contract']"
                                    :is-editable="loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN"
                                    :model-name="'Monitoring'"
                                    :size-limit="MonitoringForm.fileSizeLimit"
                                >
                                </upload-file>
                            </div>
                            <div class="clearance-bar">
                                <label>{{ $t('monitoring.title_clearance_box') }}</label>
                                <radio name="model.info_risk_assessment"
                                    class="form-check-inline"
                                    value="cleared-with-condition"
                                    v-model="amend.clearance"
                                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                    >
                                    <label>{{ $t('monitoring.field_title_cleared_under_conditions') }}</label>
                                </radio>
                                <radio name="model.info_risk_assessment"
                                    class="form-check-inline"
                                    value="cleared"
                                    v-model="amend.clearance"
                                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                    >
                                    <label>{{ $t('monitoring.field_title_cleared') }}</label>
                                </radio>
                                <radio name="model.info_risk_assessment"
                                    class="form-check-inline"
                                    value="not-cleared"
                                    v-model="amend.clearance"
                                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                    >
                                    <label>{{ $t('monitoring.field_title_not_cleared') }}</label>
                                </radio>
                            </div>
                            <comment-box
                                class="form-group"
                                v-model="amend.comments"
                                :is-editable="loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN"
                                :comments="amend.comments"
                                :pull-right="false">
                            </comment-box>
                        </div>
                    </div>

                    <base-button
                        v-if="loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN"
                        class="mt-4"
                        type="primary"
                        @click="addContractAmmendment"
                        >
                        {{ $t('monitoring.button_title_add_new_ammendment') }}
                    </base-button>
                </div>
            </div>
            <div class="row mb-5">
                <div class="col-12">
                    <div class="grant-agreement-box row mt-5">
                        <div class="col-12">
                            <div class="form-group file-group">
                                <span class="file-caption">{{ $t('monitoring.field_title_signed_budget') }}</span>
                                <upload-file
                                    v-if="MonitoringForm.initialized"
                                    v-model="MonitoringForm.files.grant_agreement.signed_budget"
                                    class="upload-file"
                                    section="grant_agreement.signed_budget"
                                    :select-text="$t('monitoring.button_title_admin_upload_budget')"
                                    :file-data="MonitoringForm.files.grant_agreement.signed_budget"
                                    :is-editable="loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN"
                                    :model-name="'Monitoring'"
                                    :size-limit="MonitoringForm.fileSizeLimit"
                                >
                                </upload-file>
                            </div>
                        </div>
                    </div>

                    <div class="ammendment-box mt-3 row" v-for="(amend, index) in MonitoringForm.model.grant_agreement.budget_amends" :key="'contract_' + index">
                        <div class="col-12">
                            <div class="form-group file-group">
                                <span class="file-caption">{{ $t('monitoring.box_title__amend_request', [index + 1]) }}</span>
                                <upload-file
                                    v-if="MonitoringForm.initialized"
                                    v-model="MonitoringForm.files.grant_agreement['amend_' + index + '_signed_budget']"
                                    class="upload-file"
                                    :select-text="$t('monitoring.button_title_upload_ammended')"
                                    :section="'grant_agreement.amend_' + index + '_signed_budget'"
                                    :file-data="MonitoringForm.files.grant_agreement['amend_' + index + '_signed_budget']"
                                    :is-editable="loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN"
                                    :model-name="'Monitoring'"
                                    :size-limit="MonitoringForm.fileSizeLimit"
                                >
                                </upload-file>
                            </div>
                            <div class="clearance-bar">
                                <label>{{ $t('monitoring.title_clearance_box') }}</label>
                                <radio name="model.info_risk_assessment"
                                    class="form-check-inline"
                                    value="cleared-with-condition"
                                    v-model="amend.clearance"
                                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                    >
                                    <label>{{ $t('monitoring.field_title_cleared_under_conditions') }}</label>
                                </radio>
                                <radio name="model.info_risk_assessment"
                                    class="form-check-inline"
                                    value="cleared"
                                    v-model="amend.clearance"
                                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                    >
                                    <label>{{ $t('monitoring.field_title_cleared') }}</label>
                                </radio>
                                <radio name="model.info_risk_assessment"
                                    class="form-check-inline"
                                    value="not-cleared"
                                    v-model="amend.clearance"
                                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN"
                                    >
                                    <label>{{ $t('monitoring.field_title_not_cleared') }}</label>
                                </radio>
                            </div>
                            <comment-box
                                class="form-group"
                                v-model="amend.comments"
                                :is-editable="loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN"
                                :comments="amend.comments"
                                :pull-right="false">
                            </comment-box>
                        </div>
                    </div>

                    <base-button
                        v-if="loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN"
                        class="mt-4"
                        type="primary"
                        @click="addBudgetAmmendment"
                        >
                        {{ $t('monitoring.button_title_add_new_ammendment') }}
                    </base-button>
                </div>
            </div>
        </div>

        <div class="row mt-5" v-if="MonitoringForm.initialized && MonitoringForm.isEditable">
            <div class="col-12">
                <base-button type="default" wide @click.native="saveProgress">{{$t('general.save_progress')}}</base-button>
                <base-button class="pull-right" wide @click.native="submit">{{$t('general.submit')}}</base-button>
            </div>
        </div>
    </div>
</template>
<script>
    import {MonitoringForm, RegionService, UserRoles} from '@/services';
    import {DatePicker} from 'element-ui';
    import Multiselect from 'vue-multiselect';
    import {CommentBox} from 'src/components';
    import {EventBus} from '@/event-bus.js';

    import MonitoringGrantAgreementsQuestions from "../../MonitoringGrantAgreementsQuestions"

    export default
    {
        components:
        {
            MonitoringForm,
            [DatePicker.name]: DatePicker,
            Multiselect,
            CommentBox,
            MonitoringGrantAgreementsQuestions
        },
        data()
        {
            return {
                UserRoles,
                MonitoringForm,
                loggedUser: this.$store.getters['Auth/loggedUser'],
                showContractDetails: false,
                startDate: '',
                endDate: '',
                amendEndDate1: '',
                amendEndDate2: '',
                moment: '',
                regions: [],
                showAmendDate2: false,
                showAmendedDates: true

            }
        },
        computed:
        {
            countriesByRegion()
            {
                let countries = [];
                let region = this.regions.filter((region) => {
                    return region.regionId === MonitoringForm.regionId;
                });

                if (region[0] !== undefined && region[0].countries !== undefined && region[0].countries.length)
                {
                    countries = region[0].countries;
                }

                return countries;
            },
            showDates(){
                if(this.loggedUser.role == this.UserRoles.APPLICANT && this.MonitoringForm.model.grant_agreement.amendment_end_date_first == null){
                    this.showAmendedDates = false;
                    return this.showAmendedDates;
                }
                else{
                    return this.showAmendedDates;
                }
            }
        },
        async beforeMount()
        {
            const vm = this;
            const loader = vm.$loading.show();

            // vm.loggedUser = vm.$store.getters['Auth/loggedUser'];

            vm.moment = require('moment');

            RegionService.getApplicationRegionsWithCountries().then((response) => {
                vm.regions = response.data;
                loader.hide();
            });

            if (!MonitoringForm.model.grant_agreement.contract_amends)
            {
                MonitoringForm.model.grant_agreement.contract_amends = [];
            }

            if (!MonitoringForm.model.grant_agreement.budget_amends)
            {
                MonitoringForm.model.grant_agreement.budget_amends = [];
            }

            vm.startDate = MonitoringForm.model.grant_agreement.start_date || '';
            vm.endDate = MonitoringForm.model.grant_agreement.end_date || '';
             //amend end date - by alan
            vm.amendEndDate1 = MonitoringForm.model.grant_agreement.amendment_end_date_first || '';
            vm.amendEndDate2 = MonitoringForm.model.grant_agreement.amendment_end_date_second || '';

            console.log(MonitoringForm);
        },
        async beforeCreate()
        {
            const vm = this;

            vm.loggedUser = vm.$store.getters['Auth/loggedUser'];

            vm.$forceUpdate();
        },
        methods:
        {
            addContractAmmendment()
            {
                MonitoringForm.model.grant_agreement.contract_amends.push({});

                this.$forceUpdate();
            },

            addBudgetAmmendment()
            {
                MonitoringForm.model.grant_agreement.budget_amends.push({});

                this.$forceUpdate();
            },

            getError(field)
            {
                return this.errors.first(field);
            },
            getError2(field)
            {
                if(this.errors.first(field)){
                    return 'Date should be greater than End Date';
                }
                else{
                    return this.errors.first(field);
                }
                
            },

            validate()
            {
                return this.$validator.validateAll().then(res =>
                {
                    this.$emit('on-validated', res, this.model);

                    return res;
                });
            },

            setRegion(ev)
            {
                MonitoringForm.regionId = parseInt(ev.target.value);
                MonitoringForm.model.grant_agreement.acp_country;
            },

            viewOriginalProposal()
            {
                window.open('/application/fill/' + MonitoringForm.grantId + '/' + MonitoringForm.applicationId, '_blank');
            },

            saveProgress()
            {
                EventBus.$emit('monitoring-save-progress');
            },

            submit()
            {
                EventBus.$emit('monitoring-submit');
            },
        },
        watch:
        {
            startDate(new_val)
            {
                const date = this.moment(new_val).format('YYYY-MM-DD');
                MonitoringForm.model.grant_agreement.start_date = (date === 'Invalid date' ? null : date);
            },
            endDate(new_val)
            {
                const date = this.moment(new_val).format('YYYY-MM-DD');
                MonitoringForm.model.grant_agreement.end_date = (date === 'Invalid date' ? null : date);
            },
            //Amend end date- by alan
            amendEndDate1(new_val)
            {
                const dt = MonitoringForm.model.grant_agreement.end_date;
                const date = this.moment(new_val).format('YYYY-MM-DD');
                if(date != 'Invalid date'){
                   this.showAmendDate2 = true;
                }
                //MonitoringForm.model.grant_agreement.amendment_end_date_1 = (date === 'Invalid date' ? null : date);
                MonitoringForm.model.grant_agreement.amendment_end_date_first = (date === 'Invalid date') ? null : (date > MonitoringForm.model.grant_agreement.end_date ? date : null);
            },
            amendEndDate2(new_val)
            {
                const date = this.moment(new_val).format('YYYY-MM-DD');
                //MonitoringForm.model.grant_agreement.amendment_end_date_2 = (date === 'Invalid date' ? null : date);
                MonitoringForm.model.grant_agreement.amendment_end_date_second = (date === 'Invalid date') ? null : (date > MonitoringForm.model.grant_agreement.amendment_end_date_first ? date : null);
            }
        }
    };
</script>
<style lang="scss" scoped>
.grant-agreement
{
    counter-reset: title_counter;
    // counter-reset: subtitle_counter;

    .card-title
    {
        counter-increment: title_counter;
        counter-reset: subtitle_counter;

        &:before
        {
            content: counter(title_counter) '. '
        }
    }

    .card-subtitle
    {
        margin: 10px 0;
        counter-increment: subtitle_counter;

        &:before
        {
            content: counter(title_counter) '.' counter(subtitle_counter) '. '
        }
    }
    .card-subtitle-new
    {
        counter-increment: alphabeticList;
        //counter-reset:alphabeticList;

        &:before
        {
            content: counter(title_counter)
        }
    }
}
</style>
